export enum WorkflowTypeGroupingOption {
  CATEGORY = 'Category',
  APP = 'App',
  CREATED_BY = 'CreatedBy',
}
